import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    width: 100%;
  }

  .profile-color-selector {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-400);
  }

  .profile-color-title {
    margin: 0;
    color: var(--sds-color-text-default-default);
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-body-size-large);
    font-weight: var(--sds-typography-weight-medium);
    line-height: 1.75;
  }

  .color-options-container {
    display: flex;
    gap: var(--sds-size-space-400);
    overflow-x: auto;
    padding: var(--sds-size-space-100) 0;
  }

  .color-option {
    width: 40px;
    height: 40px;
    border: 2px solid var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-400);
    cursor: pointer;
    transition: border-color 0.2s ease;
    flex-shrink: 0;
    background: none;
    padding: 0;
  }

  .color-option:hover {
    border-color: var(--sds-color-border-default-secondary);
  }

  .color-option.active {
    border-color: var(--sds-color-border-neutral-default);
  }

  .color-option:focus {
    outline: 2px solid var(--sds-color-border-brand-default);
    outline-offset: 2px;
  }

  .color-option.custom-option {
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--sds-color-background-default-secondary);
  }

  .color-option.custom-option ph-eyedropper {
    color: var(--sds-color-background-default-default);
  }

  .color-option.custom-option:hover ph-eyedropper {
    color: var(--sds-color-background-default-default-hover);
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
`;
